import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import RFSInfo from 'Work-Orders/Components/RFSInfo';
import { AppSettings } from '../../constants';

import * as RFSActionType from '../../Request-Services/constants';
import * as PunchListActionTypes from '../constants';

import auth from 'Auth/authenticator';
import TableList from 'components/TableList';

const defaultParams = {
  defaultSortName: 'refNo',
  defaultSortOrder: 'descending',
  sizePerPage: 100
};

class ManagePunchListItems extends Component {

  static propTypes = {
    history: PropTypes.object,
    ManageWorkOrderTypes: PropTypes.object,
    dispatch: PropTypes.func,
    match: PropTypes.object,
    location: PropTypes.object,
    PunchListProfile: PropTypes.object,
    rfsAction: PropTypes.object
  }

  constructor(props) {
    super(props);

    let punchListRefNo = null;
    if (props.match.params.punchListRefNo) {
      punchListRefNo = props.match.params.punchListRefNo;
    }

    const queryParams = new URLSearchParams(this.props.location.search);
    const tradeId = queryParams.get('tradeId');
    const clientUrl = queryParams.get('clientUrl');
    const subcontractorId = queryParams.get('subcontractor');

    this.state = {
      rfsStatus: AppSettings.RFS_STATUS_VALUE,

      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,

      currentPage: 1,
      sizePerPage: defaultParams.sizePerPage,

      punchListRefNo,

      tradeId,
      clientUrl,
      subcontractorId,

      data: [],
      column: [
        {
          field: 'refNo', header: 'WO#', hidden: false, isKey: true, sort: false, dataAlign: 'left', headerAlign: 'left',
          customRender: this.customRenderWOID.bind(this), widthStyle: 'name'
        },
        { // no require field name when using customerRender excepts key column
          field: '', header: 'Trade', dataAlign: 'left', headerAlign: 'left',
          customRender: this.customRenderTrade.bind(this), widthStyle: 'name'
        },
        {
          field: '', header: 'Summary', dataAlign: 'left', headerAlign: 'left',
          customRender: this.customRenderSummary.bind(this), widthStyle: 'address'
        },
        {
          field: '', header: 'Description', dataAlign: 'left', headerAlign: 'left',
          customRender: this.customRenderDescription.bind(this), widthStyle: 'address'
        },
        {
          field: '', header: 'Status', dataAlign: 'left', headerAlign: 'left',
          customRender: this.customRenderStatus.bind(this), widthStyle: 'name'
        }
      ]
    };

    this.defaultNumOfColumn = this.state.column.length;
  }

  componentDidMount() {
    this.fetchPunchListDetail();

    const self = this;
    window.addEventListener('click', (e) => {
      if (document.getElementById('s1-popup') && document.getElementById('s1-popup').contains(e.target)) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (document.getElementById('popup-button') && document.getElementById('popup-button').contains(e.target)) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({isShowPopup: false});
          }
        }

      }
    });

    this.updatePredicate();
    window.addEventListener('resize', this.updatePredicate);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updatePredicate);
  }

  updatePredicate = () => {
    this.setState({ isMobile: window.innerWidth < 768 });
  }

  fetchPunchListDetail() {
    this.props.dispatch({
      type: PunchListActionTypes.GET_SUBCONTRACTOR_PUNCH_LIST_DETAIL_ASYNC,
      params: {
        refNo: this.state.punchListRefNo,
        host: this.state.clientUrl,
        subcontractorId: this.state.subcontractorId,
        tradeId: this.state.tradeId
      }
    });
  }

  binding(params) {
    this.props.dispatch({
      type: RFSActionType.GET_LIST_WORK_ORDER_BY_RFSID_ASYNC,
      params: params
    });
  }

  objToParams(obj) {

    return {
      rfsId: this.state.rfsId,
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      status: obj.status,
      skip: obj.skip - 1,
      take: obj.take
    };
  }

  onTableBinding(configTable) {

    var params = this.objToParams(this.props.ManageWorkOrderTypes.params);

    this.binding({
      ...params,
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take
    });

  }

  refreshList(params) {
    this.setState({
      defaultSortName: params.defaultSortName,
      defaultSortOrder: params.defaultSortOrder,
      sizePerPage: params.sizePerPage
    }, () => {
      this.props.dispatch({
        type: RFSActionType.GET_LIST_WORK_ORDER_BY_RFSID_ASYNC,
        params: {
          rfsId: this.state.rfsId,
          sortField: params.defaultSortName,
          sortOrder: params.defaultSortOrder,
          skip: params.currentPage - 1,
          take: params.sizePerPage
        }
      });
    });
  }

  customRenderWO = (field, row) => {
    let value = get(row, field);
    return value || '';
  }

  onClickSignIn = () => {
    if (auth.loggedIn()) {
      this.props.history.push(`/punch-lists/${this.state.punchListRefNo}${this.props.location.search}`);
    }
    else {
      this.props.history.push(`/sign-in?nextUrl=/punch-lists/${this.state.punchListRefNo}${this.props.location.search}`);
    }
  }

  onClickWORefNo = item => (e) => {
    e.preventDefault();

    if (auth.loggedIn()) {
      this.props.history.push(`/punch-lists/${this.state.punchListRefNo}/punch-list-item/${item.refNo}`);
    }
    else {
      this.props.history.push(`/sign-in?nextUrl=/punch-lists/${this.state.punchListRefNo}/punch-list-item/${item.refNo}`);
    }
  }

  customRenderWOID(item) {
    return <span><a href='' onClick={this.onClickWORefNo(item)}>{item.refNo}</a></span>;
  }

  customRenderTrade(item) {
    if (item) {
      return <span>{item.trade ? item.trade.name : '-'}</span>;
    }
    return null;
  }

  customRenderSummary(item) {
    return (
      <div style={{ whiteSpace: 'break-spaces' }}>
        {item ? item.title : '-'}
      </div>
    );
  }

  customRenderDescription(item) {
    return (
      <div style={{ whiteSpace: 'break-spaces' }}>
        {item ? item.description : '-'}
      </div>
    );
  }

  customRenderStatus(item) {
    if (item.status === 0) {
      return <item.statusValue>Awaiting review</item.statusValue>;
    } else if (item.status === 6) {
      return <item.statusValue>Requested to reopen</item.statusValue>;
    } else {
      return <item.statusValue>{item.statusValue}</item.statusValue>;
    }
  }

  onToggleReviewRFS = () => {
    this.setState({ isReviewRFS: !this.state.isReviewRFS });
  }

  renderPunchListInfo = () => {
    return <RFSInfo
      RFSInformation={this.props.PunchListProfile}
      onToggleReviewRFS={this.onToggleReviewRFS}
      location={this.props.location}
      history={this.props.history}
      displayStatus={true}
      mode='punchList'
      hideHistory={true} // hide history on public page for punch list detail
      displayTab={true} />;
  }

  renderTableHeader = (data, totalRecord) => {
    return (
      <div className='table-header'>
        <div className='row'>
          <div className='col-md-12'>
            <p style={{fontSize: 20}}>Work Orders ({totalRecord})</p>
            <p>Trade: <strong>{data.length ? data[0].trade.name : ''}</strong></p>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const { PunchListProfile } = this.props;

    if (PunchListProfile) {
      const totalRecord = PunchListProfile.workOrders ? PunchListProfile.workOrders.totalRecord : 0;
      const data = PunchListProfile.workOrders ? PunchListProfile.workOrders.items : [];

      const options = {
        defaultSortName: this.state.defaultSortName, // default sort column name
        defaultSortOrder: this.state.defaultSortOrder, // default sort order,
        sizePerPage: this.state.sizePerPage,
        totalRecord: totalRecord
      };

      return (
        <div className='rfs-detail' style={{padding: 30}}>
          <div className='page-title clearfix'>
            <h2 className='pull-left'>BT #{this.state.punchListRefNo}
              <button style={{marginLeft: 20}} className='btn btn-primary btn-info btn-siteone pull-right btn-icon' onClick={this.onClickSignIn}>
                  Sign in to see more
              </button>
            </h2>
          </div>
          <div className='wrapper' style={{ minHeight: 'auto' }}>
            {PunchListProfile && PunchListProfile.project && this.renderPunchListInfo()}
          </div>

          <TableList
            column={this.state.column}
            defaultParams={defaultParams}
            pagination={false}
            data={data}
            options={options}
            refreshPageList={this.refreshList.bind(this)}
            refreshList={this.refreshList.bind(this)}
            customTableHeader={this.renderTableHeader(data, totalRecord)}
          />
        </div>
      );
    } else {
      return null;
    }
  }
}

const mapStateToProps = (state) => {
  return {
    UserProfile: state.UserStore,
    PunchListProfile: state.PunchListStore.PunchListProfile
  };
};

export default connect(mapStateToProps)(ManagePunchListItems);



// WEBPACK FOOTER //
// ./src/Punch-List/Containers/public-manage-punch-list-items.js